module.exports = __webpack_public_path__ + "img/order-success.88dfab20.png";